import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import RightArrow from 'Icons/RightArrow';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    alignSelf: 'center',
    textAlign: 'right',
    padding: theme.spacing(3),
    justifyContent: 'flex-end',
    display: 'flex',
  },
  title: {
    padding: 0,
    color: theme.palette.primary.main,
    margin: 0,
  },
  paragraph: {
    fontSize: theme.spacing(2),
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.main,
  },
  icon: {
    alignSelf: 'center',
    marginLeft: theme.spacing(2),
    height: '24px', // Not using spacing because this should never change
    width: 'auto',
    fill: theme.palette.facet.accentBlue,
  },
  childContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [theme.breakpoints.down('md')]: {
    root: {
      width: '100%',
      textAlign: 'center',
      '& > div': {
        textAlign: 'center',
        width: '100%',
      },
    },
    icon: {
      display: 'none',
    },
    childContainer: {
      justifyContent: 'center',
    },
  },
}));

export default function Description({ title, subtitle, children }) {
  const classes = useStyles();
  return (
    <>
      <div className={classes.root}>
        <div>
          <Typography variant="h1" className={classes.title}>
            {title}
          </Typography>
          <Typography variant="h5" className={classes.paragraph} component="p">
            {subtitle}
          </Typography>
        </div>
        <RightArrow fontSize="large" className={classes.icon} />
      </div>
      {children ? (
        <div className={classes.childContainer}>{children}</div>
      ) : (
        undefined
      )}
    </>
  );
}

Description.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  children: PropTypes.node,
};
Description.defaultProps = {
  children: undefined,
};
